import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'Tema',
  'common.themeLight': 'Claro',
  'common.themeDark': 'Escuro',
  'common.themeActive': 'Atualmente ativo',
  'common.themeSwitchToDark': 'Mudar para escuro',
  'common.themeSwitchToLight': 'Mudar para claro',
  'common.settings': 'Configurações',
  'common.loading': 'Carregando…',
  'settings.language': 'Idioma',
  'settings.savePreferences': 'Salvar preferências',
  'settings.savingPreferences': 'Salvando…',
  'auth.gate.userTitle': 'Verificando a sessão',
  'auth.gate.userDescription': 'Confirmando o login. Um momento.',
  'auth.gate.agentTitle': 'Verificando a sessão',
  'auth.gate.agentDescription': 'Confirmando o login do agente. Um momento.',
  'user.layout.sidebarTitle': 'MineMe Usuário',
  'user.layout.logout': 'Sair',
  'user.layout.nav.dashboard': 'Painel',
  'user.layout.nav.deposit': 'Depósito',
  'user.layout.nav.withdraw': 'Saque',
  'user.layout.nav.investments': 'Investimentos',
  'user.layout.nav.referral': 'Indicações',
  'user.layout.nav.notifications': 'Notificações',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transações',
  'user.layout.nav.settings': 'Configurações',
  'user.layout.balance.available': 'Saldo disponível',
  'user.layout.balance.frozen': 'Saldo bloqueado',
  'user.layout.balance.interest': 'Saldo de juros',
  'user.layout.balance.bonus': 'Saldo de bônus',
  'user.dashboard.balance.available': 'Saldo disponível',
  'user.dashboard.balance.frozen': 'Saldo bloqueado',
  'user.dashboard.balance.interest': 'Juros ganhos',
  'user.dashboard.balance.bonus': 'Saldo de bônus',

  'common.time.days': 'Dias',
  'common.time.hours': 'Horas',
  'common.time.minutes': 'Minutos',
  'common.time.seconds': 'Segundos',

  'user.dashboard.title': 'Painel',
  'user.dashboard.loadingInvestments': 'Carregando status do investimento…',
  'user.dashboard.stats.totalInvested': 'Total investido',
  'user.dashboard.stats.netPnl': 'Lucro / prejuízo líquido',
  'user.dashboard.stats.activePlans': 'Planos ativos',
  'user.dashboard.noInvestment.title': 'Sem investimento ativo',
  'user.dashboard.noInvestment.subtitle':
    'Comece a investir hoje e faça seu patrimônio crescer com retornos atraentes',
  'user.dashboard.noInvestment.cta': 'Explorar planos de investimento',
  'user.dashboard.recentTx.title': 'Transações recentes',
  'user.dashboard.recentTx.viewAll': 'Ver todas',
  'user.dashboard.recentTx.col.date': 'Data',
  'user.dashboard.recentTx.col.type': 'Tipo',
  'user.dashboard.recentTx.col.description': 'Descrição',
  'user.dashboard.recentTx.col.amount': 'Valor',
  'user.dashboard.recentTx.col.status': 'Status',
  'user.dashboard.recentTx.loading': 'Carregando transações recentes…',
  'user.dashboard.recentTx.empty': 'Nenhuma transação recente.',
  'user.dashboard.tx.Deposit': 'Depósito',
  'user.dashboard.tx.Investment': 'Investimento',
  'user.dashboard.tx.Referral': 'Indicação',
  'user.dashboard.tx.Bonus': 'Bônus',
  'user.dashboard.tx.Withdrawal': 'Saque',
  'user.dashboard.tx.E-Voucher': 'Voucher eletrônico',
  'user.dashboard.tx.Stop-Loss': 'Stop-loss',
  'user.dashboard.st.Completed': 'Concluído',
  'user.dashboard.st.Active': 'Ativo',
  'user.dashboard.st.Pending': 'Pendente',
  'user.dashboard.st.Failed': 'Falhou',
  'user.dashboard.invest.planFallback': 'Plano',
  'user.dashboard.invest.activeBadge': 'Ativo',
  'user.dashboard.invest.detail.amountInvested': 'Valor investido',
  'user.dashboard.invest.detail.currentValue': 'Valor atual',
  'user.dashboard.invest.detail.pl': 'L/P',
  'user.dashboard.invest.detail.interestRate': 'Taxa de juros',
  'user.dashboard.invest.detail.perMonth': '{{pct}}% ao mês',
  'user.dashboard.invest.detail.duration': 'Duração',
  'user.dashboard.invest.detail.months': '{{n}} meses',
  'user.dashboard.invest.detail.startDate': 'Data de início',
  'user.dashboard.invest.detail.nextWithdrawal': 'Próximo saque',
  'user.dashboard.invest.countdownTitle': 'Próximo saque em',
  'user.dashboard.invest.progress': 'Progresso',
  'user.dashboard.invest.progressPct': '{{pct}}% concluído',
  'user.dashboard.invest.earlyWithdraw': 'Saque antecipado',
  'user.dashboard.invest.planChip': '{{name}} nº {{num}}',
  'user.dashboard.invest.modal.title': 'Aviso de saque antecipado',
  'user.dashboard.invest.modal.investmentAmount': 'Valor investido:',
  'user.dashboard.invest.modal.platformFee': 'Taxa da plataforma ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'Juros perdidos:',
  'user.dashboard.invest.modal.youWillReceive': 'Você receberá:',
  'user.dashboard.invest.modal.confirmHint': 'Digite CONFIRM para continuar',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Confirmar saque',
  'user.dashboard.invest.modal.cancelling': 'Cancelando…',
  'user.dashboard.invest.toast.cancelled': 'Investimento cancelado',
  'user.dashboard.invest.toast.cancelFailed': 'Não foi possível cancelar',

  'notifications.bell.triggerAria': 'Notificações',
  'notifications.bell.title': 'Notificações',
  'notifications.bell.loading': 'Carregando…',
  'notifications.bell.loadErrorSubtitle': 'Não foi possível carregar as notificações',
  'notifications.bell.unreadOne': '1 atualização não lida',
  'notifications.bell.unreadMany': '{{count}} atualizações não lidas',
  'notifications.bell.allCaughtUp': 'Tudo em dia',
  'notifications.bell.markAllRead': 'Marcar todas como lidas',
  'notifications.bell.empty': 'Ainda não há notificações',
  'notifications.bell.emptyError': 'Não foi possível carregar as notificações',
  'notifications.bell.viewAll': 'Ver todas',
  'notifications.bell.markReadAria': 'Marcar como lida',
  'notifications.bell.time.justNow': 'agora',
  'notifications.bell.time.secondsAgo': 'há {{n}} s',
  'notifications.bell.time.minutesAgo': 'há {{n}} min',
  'notifications.bell.time.hoursAgo': 'há {{n}} h',
  'notifications.bell.time.daysAgo': 'há {{n}} d',

  'agent.layout.logout': 'Sair',
  'agent.layout.nav.dashboard': 'Painel',
  'auth.user.login.title': 'Login do usuário',
  'auth.user.login.signIn': 'Entrar',
  'auth.agent.login.title': 'Login do agente',
  'auth.agent.login.signIn': 'Entrar',

  ...panelSettingsTransactionsByLang.pt,
  ...panelReferralRankingByLang.pt,
  ...panelUserExtraByLang.pt,
  ...panelDwiOverrides.pt,
  ...panelDepositBonusByLang.pt,
  ...panelVoucherStatusByLang.pt,
  ...panelWithdrawBep20ByLang.pt,
  ...panelDepositVoucherOverrides.pt,
  ...panelInvestmentsOverrides.pt,
  'user.investments.card.dailyProfit': 'Lucro diário',
  'user.investments.card.earningDays': 'Dias úteis',
  'user.investments.card.earningDaysValue': '{{count}} dias úteis',
  'user.investments.card.expectedProfit': 'Lucro esperado',
  'user.investments.card.investLimit': 'Limite de investimento',
  'user.investments.card.investLimitLine': '{{count}}× em {{days}} dias',
  'user.investments.card.investLimitReached':
    'Você atingiu o limite de investimento deste plano no período atual.',
  'user.investments.card.limitReached': 'Limite atingido',
  ...panelStopLossSlotsAssignOverrides.pt,
  ...panelStopLossFlowByLang.pt,
  ...panelUserSignupSocialForgotByLang.pt,
  ...panelAgentDashboardByLang.pt,
  ...panelAgentReferralsByLang.pt,
  ...panelAgentCommissionsByLang.pt,
  ...panelAgentWithdrawByLang.pt,
  ...panelAgentWithdrawUnlockStringsByLang.pt,
  'agent.withdraw.unlock.loadingTitle': 'Verificando status de saque…',
  'agent.withdraw.unlock.loadingSubtitle':
    'Carregando seu progresso de indicações e requisitos de desbloqueio',
  'agent.withdraw.form.loadingTitle': 'Carregando detalhes do saque…',
  'agent.withdraw.form.loadingHint': 'Aguarde enquanto carregamos seu saldo e status de desbloqueio',
  'agent.withdraw.unlock.requirementMet': 'Requisito atendido',
  'agent.withdraw.unlock.minDepositHint':
    'Apenas usuários indicados contam (não sub-agentes). Cada um precisa de pelo menos ${{amount}} em depósitos concluídos.',
  ...panelAgentTransactionsByLang.pt,
  ...panelAgentLogsByLang.pt,
  ...panelAgentSettingsByLang.pt,
  ...panelAgentNotificationsByLang.pt,
  ...panelAgentTeamByLang.pt,
  ...panelAgentSignupByLang.pt,
  ...panelAgentLayoutByLang.pt,
  ...panelAgentAuthByLang.pt,
  ...panelUserPlatformTodayByLang.pt,
  ...panelStopLossHowLayoutByLang.pt,
  ...panelSupportTicketsByLang.pt,
});
